import Icon from 'veui/components/Icon'

Icon.register({
  'city-buildings': {
    paths: [
      {
        d: 'M28 10.67h-4V1.95a1.33 1.33 0 00-2.07-1.1l-8 5.33c-.37.24-.6.66-.6 1.1V16h-2.66v-3.42c0-.47-.25-.9-.65-1.15L4.69 8.2a1.34 1.34 0 00-2.02 1.14v17.34c0 .73.6 1.33 1.33 1.33h24c.74 0 1.33-.6 1.33-1.33V12c0-.74-.6-1.33-1.33-1.33zM16 8l5.33-3.56v20.9h-2.66v-8c0-.74-.6-1.34-1.34-1.34H16V8zM5.33 11.69L8 13.33v12H5.33V11.7zm9.34 13.64h-4v-6.66H16v6.66h-1.33zm12 0H24v-12h2.67v12z'
      }
    ],
    width: '32',
    height: '32'
  }
})
